import { qs } from '../../assets/js/src/scripts.js';
// import { galaxoStats } from '../../../src/assets/js/src/scripts-galaxo.js';

//import $ from "jquery";

var $ = require('jquery');
require('jquery-sendkeys');

var $search = $('.galaxo-search');
var $searchInput = $search.find('input');
//var $search = document.querySelector('.galaxo-search');
//var $searchInput = $search.getElementsByTagName('input');

function init(store) {

	//window.$ = window.jQuery;

	var userList;
	//var $itemList = $('.galaxo-search__list');

	// Fix links
	// $itemList.find('a').each(function() {
	// 	this.href = this.getAttribute('data-href');
	// });

	// Initialize filtering plugin
	userList = new List('galaxo-search__form', {
		valueNames: ['title2']
	});
	userList.search('initial_dymmy_search_to_clear_list');

	// Don't show search items if the search input is empty
	userList.on('searchComplete', function(e) {
		if ($.trim($searchInput.val())) {
			$search.find('.galaxo-search__list').removeClass('hide-all');
		} else {
			$search.find('.galaxo-search__list').addClass('hide-all');
		}
	});

	// Show / hide search
	$('.nav-galaxo').on('mousedown', '.btn--search', function(e) {
		e.preventDefault();
		if ($search.hasClass('is-active')) {
			hide();
		} else {
			show();
		}
	});

	// Hide search
	$search.on('mousedown', '.galaxo-search__close', function(e) {
		$('.galaxo-search').removeClass('is-active');
		$searchInput.blur();
	});

	// Keyboard
	$search.on('mousedown', '.galaxo-search__keyboard-row button, .galaxo-search__reset', function() {

		var value = $(this).data('value') || $(this).text();

		if (value === 'reset') {
			$searchInput.val('');
		} else {
			$searchInput.sendkeys(value);
		}

		userList.search($searchInput.val(), ['title2']);

	});

	// Highlight search item text
	userList.on('searchComplete', function(e) {

		var searchTerm = $searchInput.val();

		userList.matchingItems.forEach(function(item) {
			var $title = $(item.elm).find('.title');
			var text = $title.text();
			$title.html(highlightSubstring(text, searchTerm));
		});
	});

	$search.on('mousedown', 'a', function(e) {
		var $link = $(this);
		var title = $link.find('.title2').text();
		var searchTerm = $searchInput.val();

		e.preventDefault();

		if (document.body.matches('.tpl-map')) {

			let params = qs.parse($link[0].hash.substr(1));

			//galaxoStats.send('search', title, searchTerm);

			store.dispatch({
				type: 'LOAD_ROUTE',
				route: params
			});

			hide();
		}

	});

	// Trigger stats
	/*
	$search.on('mousedown', 'a', function(e) {
		var $link = $(this);
		var title = $link.find('.title2').text();
		var searchTerm = $searchInput.val();

		e.preventDefault();

		if (document.body.matches('.tpl-map')) {

			let params = qs.parse($link[0].hash.substr(1));

			//galaxoStats.send('search', title, searchTerm);

			store.dispatch({
				type: 'LOAD_ROUTE',
				route: params
			});

			hide();

		} else {

			document.location.href = $link.attr('href');

			//galaxoStats.send('search', title, searchTerm).always(function() {
			//	setTimeout(function() {
			//		document.location.href = $link.attr('href');
			//	}, 1);
			//});

		}

	});
	*/

	$search.on('click', 'a', function(e) {
		e.preventDefault();
	});

}

// http://stackoverflow.com/questions/280793/case-insensitive-string-replacement-in-javascript
function preg_quote(str) {
    // http://kevin.vanzonneveld.net
    // +   original by: booeyOH
    // +   improved by: Ates Goral (http://magnetiq.com)
    // +   improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
    // +   bugfixed by: Onno Marsman
    // *     example 1: preg_quote("$40");
    // *     returns 1: '\$40'
    // *     example 2: preg_quote("*RRRING* Hello?");
    // *     returns 2: '\*RRRING\* Hello\?'
    // *     example 3: preg_quote("\\.+*?[^]$(){}=!<>|:");
    // *     returns 3: '\\\.\+\*\?\[\^\]\$\(\)\{\}\=\!\<\>\|\:'

    return (str + '').replace(/([\\\.\+\*\?\[\^\]\$\(\)\{\}\=\!\<\>\|\:])/g, "\\$1"); // eslint-disable-line
}

function highlightSubstring(string, substring) {
	// var reg = new RegExp(string, 'gi');
	// return string.replace(reg, function(substring) { return '<mark>' + substring + '</mark>'; });
	return string.replace(new RegExp("(" + preg_quote( substring ) + ")" , 'i' ), "<mark>$1</mark>" ); // eslint-disable-line
}

function show() {
	$search.addClass('is-active');
	$searchInput.focus();
}

function hide() {
	$search.removeClass('is-active');
	$searchInput.blur();
}

export default {
	init,
	show,
	hide
};
